import { useContext, useEffect, useState } from "react";
import { getAllRubros } from "../services/rubros.service";
import { IRubro } from "../types/producto";
import { TenantsContext } from "../../../context/tenants.context";

const useRubros = () => {
  const [rubros, setRubros] = useState<IRubro[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { tenant } = useContext(TenantsContext);

  useEffect(() => {
    setLoading(true);
    getAllRubros(tenant)
      .then((result) => {
        setRubros(result.data.data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, []);

  return {
    rubros,
    loading,
  };
};
export default useRubros;
